import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgQrCodeScanner(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 0.754761C1.30964 0.754761 0.75 1.3144 0.75 2.00476L0.75 9.00604H3.25L3.25 3.25476L9 3.25476V0.754761L2 0.754761Z"
      />
      <path
        fill="currentColor"
        d="M28.75 23.0037V28.755H23V31.255H30C30.3315 31.255 30.6495 31.1233 30.8839 30.8889C31.1183 30.6545 31.25 30.3365 31.25 30.005V23.0037H28.75Z"
      />
      <path
        fill="currentColor"
        d="M28.75 3.25476L23 3.25476V0.754761L30 0.754761C30.3315 0.754761 30.6495 0.886457 30.8839 1.12088C31.1183 1.3553 31.25 1.67324 31.25 2.00476V9.00604H28.75V3.25476Z"
      />
      <path
        fill="currentColor"
        d="M3.25 23.0037L3.25 28.755H9V31.255H2C1.30964 31.255 0.75 30.6954 0.75 30.005L0.75 23.0037H3.25Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.4165 6.66724C5.4165 5.97688 5.97615 5.41724 6.6665 5.41724L13.9258 5.41724C14.6161 5.41724 15.1758 5.97688 15.1758 6.66724V13.9278C15.1758 14.6182 14.6161 15.1778 13.9258 15.1778H6.6665C5.97615 15.1778 5.4165 14.6182 5.4165 13.9278L5.4165 6.66724ZM7.9165 7.91724L7.9165 12.6778H12.6758V7.91724L7.9165 7.91724Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.6665 16.826C5.97615 16.826 5.4165 17.3857 5.4165 18.076L5.4165 25.3366C5.4165 26.027 5.97615 26.5866 6.6665 26.5866L13.9258 26.5866C14.6161 26.5866 15.1758 26.027 15.1758 25.3366V18.076C15.1758 17.3857 14.6161 16.826 13.9258 16.826L6.6665 16.826ZM7.9165 24.0866L7.9165 19.326L12.6758 19.326V24.0866L7.9165 24.0866Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.8242 6.66724C16.8242 5.97688 17.3839 5.41724 18.0742 5.41724L25.3335 5.41724C26.0238 5.41724 26.5835 5.97688 26.5835 6.66724L26.5835 13.9278C26.5835 14.6182 26.0238 15.1778 25.3335 15.1778H18.0742C17.3839 15.1778 16.8242 14.6182 16.8242 13.9278L16.8242 6.66724ZM19.3242 7.91724L19.3242 12.6778H24.0835L24.0835 7.91724L19.3242 7.91724Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M18.0742 16.826C17.3839 16.826 16.8242 17.3857 16.8242 18.076V19.1131C16.8242 19.8034 17.3839 20.3631 18.0742 20.3631H19.1113C19.8016 20.3631 20.3613 19.8034 20.3613 19.1131V18.076C20.3613 17.3857 19.8016 16.826 19.1113 16.826H18.0742Z"
      />
      <path
        fill="currentColor"
        d="M23.0464 18.076C23.0464 17.3857 23.606 16.826 24.2964 16.826H25.3334C26.0238 16.826 26.5834 17.3857 26.5834 18.076V19.1131C26.5834 19.8034 26.0238 20.3631 25.3334 20.3631H24.2964C23.606 20.3631 23.0464 19.8034 23.0464 19.1131V18.076Z"
      />
      <path
        fill="currentColor"
        d="M18.0742 23.0499C17.3839 23.0499 16.8242 23.6095 16.8242 24.2999V25.3369C16.8242 26.0273 17.3839 26.5869 18.0742 26.5869H19.1113C19.8016 26.5869 20.3613 26.0273 20.3613 25.3369V24.2999C20.3613 23.6095 19.8016 23.0499 19.1113 23.0499H18.0742Z"
      />
      <path
        fill="currentColor"
        d="M23.0464 24.2999C23.0464 23.6095 23.606 23.0499 24.2964 23.0499H25.3334C26.0238 23.0499 26.5834 23.6095 26.5834 24.2999V25.3369C26.5834 26.0273 26.0238 26.5869 25.3334 26.5869H24.2964C23.606 26.5869 23.0464 26.0273 23.0464 25.3369V24.2999Z"
      />
      <path
        fill="currentColor"
        d="M21.1851 19.9385C20.4947 19.9385 19.9351 20.4981 19.9351 21.1885V22.2255C19.9351 22.9159 20.4947 23.4755 21.1851 23.4755H22.2221C22.9125 23.4755 23.4721 22.9159 23.4721 22.2255V21.1885C23.4721 20.4981 22.9125 19.9385 22.2221 19.9385H21.1851Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgQrCodeScanner);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
